export default __webpack_public_path__ + "static/media/img_blog06.f39c67e3.jpg";